import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { LoaderService } from '../../core/services/loader.service';
import { ManageSettingsService } from '../manage-settings/manage-settings.service';
import { CommonService } from '../../shared/services/common.service';
import { ErrorResponse } from '../../core/models/error.models';
import { Observable, Subject, takeUntil } from 'rxjs';
import { ReferenceMaterials } from '../manage-settings/manage-settings.interface';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { AuthService } from '../../core/services/auth.service';
import { OrganizationDetailModel } from '../organizations/organization.interface';

@Component({
  selector: 'app-support',
  standalone: true,
  imports: [
    NzCollapseModule,
    NzButtonModule,
    SvgIconComponent,
    NzIconModule,
    CommonModule,
    NzSpinModule,
    NzButtonModule,
  ],
  templateUrl: './support.component.html',
  styleUrl: './support.component.scss',
})
export class SupportComponent implements OnDestroy {
  organizationId = 4519;
  referenceMaterials: ReferenceMaterials[] = [];
  panels = [
    {
      active: true,
      disabled: false,
      name: 'District Reference Materials',
      content: this.referenceMaterials,
    },
    {
      active: false,
      disabled: false,
      name: 'Reference Downloads',
    },
    {
      active: false,
      disabled: true,
      name: 'Behavior Management',
    },
    {
      active: false,
      disabled: false,
      name: 'E-learning',
    },
    {
      active: false,
      disabled: false,
      name: 'Contact Us',
    },
  ];
  selectedPanel: boolean[] = [];
  private readonly destroy$ = new Subject<void>();
  loading$: Observable<boolean>;
  orgData: OrganizationDetailModel | null = null;
  constructor(
    private readonly loaderService: LoaderService,
    private readonly manageSettingService: ManageSettingsService,
    private readonly commonService: CommonService,
    private readonly authService: AuthService
  ) {
    this.loading$ = this.loaderService.loading$;
    this.authService.orgData$.pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.orgData = res;
      this.organizationId = this.orgData?.organizationId || 0;
    });
    this.loadReferenceMaterials();
    for (const ele of this.panels) {
      this.selectedPanel.push(ele.active);
    }
  }

  private loadReferenceMaterials(): void {
    this.loaderService.show();
    this.manageSettingService
      .getReferenceMaterials({
        pageIndex: 1,
        pageSize: 500,
        organizationId: this.organizationId,
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          if (response.result) {
            this.referenceMaterials = response.result.items;
            this.panels[0].content = this.referenceMaterials;
          }
        },
        error: ({ errors, message }: ErrorResponse) => {
          const errorMessages = errors.map(
            err => err.description || err.detailedMessage
          );
          this.commonService.notify('error', errorMessages, message);
        },
        complete: () => {
          this.loaderService.hide();
        },
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  downloadFile(attachment: ReferenceMaterials): void {
    window.open(attachment.fileUrl, '_blank');
  }

  onPanelChange(index: number, isActive: boolean): void {
    this.panels[index].active = isActive;
    this.selectedPanel[index] = isActive;
  }
}
